/* eslint-disable */
import Long from 'long';
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'com.celertech.midrate.api.price';

export interface MidRateSubscriptionRequest {
    throttleDelayInMillis: string;
}

function createBaseMidRateSubscriptionRequest(): MidRateSubscriptionRequest {
    return { throttleDelayInMillis: '0' };
}

export const MidRateSubscriptionRequest = {
    encode(message: MidRateSubscriptionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.throttleDelayInMillis !== '0') {
            writer.uint32(8).int64(message.throttleDelayInMillis);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): MidRateSubscriptionRequest {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMidRateSubscriptionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.throttleDelayInMillis = longToString(reader.int64() as Long);
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<MidRateSubscriptionRequest>): MidRateSubscriptionRequest {
        const message = createBaseMidRateSubscriptionRequest();
        message.throttleDelayInMillis = object.throttleDelayInMillis ?? '0';
        return message;
    }
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
    ? T
    : T extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepPartial<U>>
    : T extends {}
    ? { [K in keyof T]?: DeepPartial<T[K]> }
    : Partial<T>;

function longToString(long: Long) {
    return long.toString();
}

if (_m0.util.Long !== Long) {
    _m0.util.Long = Long as any;
    _m0.configure();
}
